import React from 'react';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ConfirmationButton } from '../../common/components/formControls';
import { ButtonToolbar } from 'react-bootstrap';
import { faEdit, faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const List = ({ t, onDelete, allowDeleteCompleted, ...rest }) => {
	const columns = [
		{
			header: t('IndividualConsultationForm_Name'),
			accessor: 'form.name',
			sortable: true,
			cell: (name) => t(`AssessmentForm_Consultation_${name}`)
		},
		{
			header: t('IndividualConsultationForm_Status'),
			accessor: 'status',
			cell: (status) => t(`FormStatus_${status.name}`),
			sortable: true
		},
		{
			header: t('IndividualConsultationForm_Modified'),
			accessor: 'date',
			sortable: true,
			cell: date => ui.formatDate(date)
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id, row) => {
				const completed = row.status.id === 3;
				const viewEditButton = (completed || row.form.isTeacherForm) &&
					<Link to={`/individualConsultationForms/${id}`} className='btn btn-teal' style={{ marginBottom: '5px', marginRight: '5px' }}><FontAwesomeIcon icon={completed ? faEye : faEdit} /> {completed ? t('Common_View') : t('Common_Edit')}</Link>;
				const deleteButton = (!completed || allowDeleteCompleted) && row.form.isTeacherForm && <ConfirmationButton onConfirmation={() => onDelete(id)}
					confirmationTitle={t('IndividualConsultationForm_DeleteConfirmationTitle')}
					confirmationMessage={t('IndividualConsultationForm_DeleteConfirmationMessage')}
					displayType={'inline'} label={t('Common_Delete')} />;
				return <ButtonToolbar>{viewEditButton}{deleteButton}</ButtonToolbar>;
			}
		}
	];

	return (
		<div>
			<PagedEntitiesList columns={columns} {...rest} />
		</div>
	);
};

export default withTranslation()(List);